import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';
import { ISiTabConfig } from '../interfaces/si-tab-config.interface';
import { SiTabConfig } from '../models/si-tab-config.model';
import Modal from 'bootstrap/js/dist/modal';
declare var $;
@Injectable({
  providedIn: 'root'
})
export class SiDataService {

  private baseUrl: string = 'si/service';
  private userPreferences: any;
  private _listners = new Subject<any>();
  private tabList: Array<string> = [];
  private tabMapping: Array<ISiTabConfig> = [];

  constructor(private http: HttpClient, private siAuthenticationService: SiAuthenticationService, private cookieService: CookieService) {

    const tabList = [{
      tabId: 'highRunners',
      path: 'highRunners',
      tabName: 'High Runners',
      tabSequence: 1
    }, {
      tabId: 'providerInsights',
      path: 'providerInsights',
      tabName: 'Provider Insights',
      tabSequence: 2
    }, {
      tabId: 'industryHighRunners',
      path: 'industryHighRunners',
      tabName: 'Industry High Runners',
      tabSequence: 3
    }, {
      tabId: 'robocallScoring',
      path: 'robocallScoring',
      tabName: 'Robocall Scoring',
      tabSequence: 4
    }, {
      tabId: 'categoryReport',
      path: 'categoryReport',
      tabName: 'Category Report',
      tabSequence: 5
    }, {
      tabId: 'scoreDistribution',
      path: 'scoreDistribution',
      tabName: 'Score Distribution',
      tabSequence: 6
    }, {
      tabId: 'RMDB',
      path: 'RMDB',
      tabName: 'RMDB',
      tabSequence: 7
    }, {
      tabId: 'userAdmin',
      path: 'userAdmin',
      tabName: 'User Management',
      tabSequence: 8
    }];

    tabList.forEach((tab) => {
      this.tabMapping.push(new SiTabConfig(tab.tabName, tab.tabId, tab.path, tab.tabSequence));
    });

  }

  getData(endPoint: string): Observable<any> {
    return this
      .http
      .get(`${this.baseUrl}/${endPoint}`);
  }

  postData(endPoint: string, data): Observable<any> {
    return this
      .http
      .post(`${this.baseUrl}/${endPoint}`, data, { responseType: 'text' });
  }

  getDataByParam(endPoint: string, params): Observable<any> {
    return this
      .http
      .get(`${this.baseUrl}/${endPoint}`, { params: params });
  }

  deleteData(endPoint: string, params): Observable<any> {
    return this
      .http
      .delete(`${this.baseUrl}/${endPoint}`, { params: params });
  }

  uploadData(endPoint: string, params, fileData): Observable<any> {
    const headerObj = {
    };
    if (this.cookieService.get('ximssession') || this.siAuthenticationService.getAuthToken()) {
      headerObj['authtoken'] = this.cookieService.get('ximssession') || this.siAuthenticationService.getAuthToken();
    }
    if (this.siAuthenticationService.getWebToken()) {
      headerObj['webtoken'] = this.siAuthenticationService.getWebToken();
    }
    const httpOptions = {
      headers: new HttpHeaders(headerObj)
    };
    return this
      .http
      .post(`${this.baseUrl}/${endPoint}?createdBy=${params.createdBy}&carrier=${params.carrier}`, fileData, httpOptions);
  }

  getDataAdmin(endPoint: string, headers): Observable<any> {
    return this
      .http
      .get(`${this.baseUrl}/${endPoint}`, { headers });
  }

  deleteDataAdmin(endPoint: string, headers): Observable<any> {
    return this
      .http
      .delete(`${this.baseUrl}/${endPoint}`, { headers });
  }

  uploadDataAdmin(endPoint: string, params, headers): Observable<any> {
    return this
      .http
      .post(`${this.baseUrl}/${endPoint}`, params, { headers });
  }

  filter(filterBy: any, auto_refresh: any) {
    const newfilterObj = { timezone: filterBy.code, auto_refresh: auto_refresh, abbr: filterBy.abbr };
    this._listners.next(newfilterObj);
    this.setPreferences(newfilterObj);
  }

  setPreferences(userPreferences) {
    this.userPreferences = userPreferences;
  }
  getPreferences() {
    return this.userPreferences;
  }

  listen(): Observable<any> {
    return this._listners.asObservable();
  }

  callHeaderLink(actionName) {
    const headerDownloadElement = document.getElementById('headerFileDownload');
    const headerDownloadModalInstance = new Modal(headerDownloadElement);
    if (actionName[1] === 'userGuide') {
      // this.isUserGuide = true;
      const res = this.getUserGuideObj().subscribe(
        (response) => {
          // this.isUserGuide = false;
          window.open(response['presignedURL'], '_blank');
        });
    }
    if (actionName[1] === 'goToRMPortal') {
      window.open('https://ng-qa-hosted-kms.dev.ccid.neustar.biz/ccid/portal/login', '_blank');
    }

    if (actionName[1] === 'fileDownload') {
      headerDownloadModalInstance.show();
      headerDownloadElement.focus();
    }

    if (actionName[1] === 'customerSupport') {
      window.open('https://www.support.neustar/NSPvCustomLogin?startURL=%2F', '_blank');
    }
  }

  getUserGuideObj(): Observable<Array<object>> {
    const userGuideURI: string = `s3/customer/userguide`;
    return new Observable<Array<object>>((observer) => {
      this.getData(userGuideURI)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  setTabList(tabList) {
    this.tabList = tabList;
  }

  getTabList() {
    return this.tabList;
  }

  getTabMapping() {
    const tabMapping = this.tabMapping.filter((tab) => this.tabList.indexOf(tab.getTabId()) !== -1);

    return tabMapping.sort((a, b) => a.getTabSequence() - b.getTabSequence());
  }


}





